// Variable edit components
import * as _ from 'underscore';

import { ColorBoxField } from '../../../../../_common/platform/ts/ColorBoxField';
import SelectField from '../../../../../_common/platform/ts/SelectField';
import NumberField from '../../../../../_common/platform/ts/NumberField';
import StringField from '../../../../../_common/platform/ts/StringField';
import BooleanField from '../../../../../_common/platform/ts/BooleanField';
import { DateTimeField } from '../../../../../_common/platform/tsx/DateField';

import { PatternsManager } from '../PatternsManager';

import { DST_SwitchingDaysClassField } from '../components/DST_SwitchingDaysClassField';

import { validators } from '../../../../../_common/platform/ts/validators';
import { validators as SchedulerValidators } from '../components/validators';

import * as appTheme from '../../../../../_common/platform/ts/appTheme';

// Any dependency themes, which should be initialized before this one
import { init as widgetTheme } from '../../../../../pdc-platform/src/ts/themes/widgetTheme';

import { themeFields, periodSelectionOptions, towSpanCalculation } from '../Interfaces';
import { scalingCodeDef, scalingValuesDef, minTimeCellWidth } from '../Interfaces';

import { getMinDate, getMaxDate } from '../utilities';
import { RadioGroupField } from '../../../../platform/ts/RadioGroupField';

declare var require: any;
//var ThemePreview = require('./ThemePreview');

// CSS template for the widget
var template = require('!!raw-loader!./mainTheme.template.css').default;

// A hack, to make sure that TS compiler will include this module as dependency in generated AMD
template;

declare var Color: any;
declare var pdc: any;

// This array, which saves all glob objects, on which theme was initialized
// It's used to make sure that `init` is launched only once for each glob.
// Here, it's possible that platform will run init for widgetTheme more than 1 time.
var _init = [];

export function init(glob) {
    // If init already invoked – halt
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    // Init parent theme
    widgetTheme(glob);

    // Register section, which will be displayed on the left of theme edit component
    appTheme.registerSections([
        {
            id: themeFields.themeSection_Main, // 'widget-gantt'
            name: 'Gantt',
            parent: 'widget',
            //preview: ThemePreview,
            //previewClassName: 'preview-widget preview-widget-gantt',

            themeType: 'Widget Gantt',
            visibility: ['application', 'workspace', 'pdc-widget-gantt']
        },

        {
            id: themeFields.themeSection_DataRetrieving,
            name: 'Data Retrieving',
            parent: themeFields.themeSection_Main,
            themeType: 'Widget Gantt',
            visibility: ['application', 'workspace', 'pdc-widget-gantt']
        },

        {
            id: themeFields.themeSection_TimeLine,
            name: 'Time Line',
            parent: themeFields.themeSection_Main,
            themeType: 'Widget Gantt',
            visibility: ['application', 'workspace', 'pdc-widget-gantt']
        },

        {
            id: themeFields.themeSection_Header,
            name: 'Gantt Header',
            parent: themeFields.themeSection_Main,
            themeType: 'Widget Gantt',
            visibility: ['application', 'workspace', 'pdc-widget-gantt']
        },

        {
            id: themeFields.themeSection_Margins,
            name: 'Margins',
            parent: themeFields.themeSection_Main,

            //preview: ThemePreview,
            //previewClassName: 'preview-widget-gauge-linear',
            themeType: 'Widget Gantt',
            visibility: ['application', 'workspace', 'pdc-widget-gantt']
        },

        {
            id: themeFields.themeSection_Slider,
            name: 'Slider',
            parent: themeFields.themeSection_Main,
            themeType: 'Widget Gantt',
            visibility: ['application', 'workspace', 'pdc-widget-gantt']
        },

        {
            id: themeFields.themeSection_Bars,
            name: 'Bars',
            parent: themeFields.themeSection_Main,
            themeType: 'Widget Gantt',
            visibility: ['application', 'workspace', 'pdc-widget-gantt']
        },

        {
            id: themeFields.themeSection_SCORE,
            name: 'SCORE Bars',
            parent: themeFields.themeSection_Bars,

            //preview: ThemePreview,
            //previewClassName: 'preview-widget-gauge-linear',
            themeType: 'Widget Gantt',
            visibility: ['application', 'workspace', 'pdc-widget-gantt']
        },

        {
            id: themeFields.themeSection_Standplan,
            name: 'Standplan Bars',
            parent: themeFields.themeSection_Bars,
            themeType: 'Widget Gantt',
            visibility: ['application', 'workspace', 'pdc-widget-gantt']
        }
    ]);

    appTheme.registerGroups([
        // - DataRetrieving

        {
            id: themeFields.themeGroup_DataRetrieving,
            name: 'Data Retrieving',
            section: themeFields.themeSection_DataRetrieving
        },
        {
            id: themeFields.themeGroup_PeriodSelecton,
            name: 'Period Selecton',
            section: themeFields.themeSection_DataRetrieving
        },

        // - TimeLine

        {
            id: themeFields.themeGroup_TimeLine,
            name: 'Time Line',
            section: themeFields.themeSection_TimeLine
        },
        {
            id: themeFields.themeGroup_ZoomBox,
            name: 'Zoom Box',
            section: themeFields.themeSection_TimeLine
        },
        {
            id: themeFields.themeGroup_Scaling,
            name: 'Scaling',
            section: themeFields.themeSection_TimeLine
        },
        {
            id: themeFields.themeGroup_DST,
            name: 'Daylight Saving Time, switching to Summer and Winter Time',
            section: themeFields.themeSection_TimeLine
        }
    ]);

    // Register theme variables
    appTheme.registerVars([
        {
            id: themeFields.ganttBackgroundColor, 
            param: new ColorBoxField(this.glob, 'Gantt Panes Background Color', [], 
                //'white', 
                function (theme) {
                    return theme['widget-bg']; 
                },
                { hideTransparency: false }
            ),
            section: themeFields.themeSection_Main
        },
        {
            id: themeFields.ganttFontColor, 
            param: new ColorBoxField(this.glob, 'Gantt Panes Font Color', [], 
                function (theme) {
                    return theme['gray-base']; 
                },
                { hideTransparency: true }
            ),
            section: themeFields.themeSection_Main
        },
        {
            id: themeFields.ganttControlsBackgroundColor, 
            param: new ColorBoxField(this.glob, 'Gantt Header Controls/Buttons Background Color', [], 
                function (theme) {
                    return theme['widget-bg']; 
                },
                { hideTransparency: false }
            ),
            section: themeFields.themeSection_Main
        },
        {
            id: themeFields.ganttControlsBackgroundColor_selected, 
            param: new ColorBoxField(this.glob, 'Gantt Header Controls/Buttons Background Color - Selected', [], 
                '#cccccc',
                { hideTransparency: false }
            ),
            section: themeFields.themeSection_Main
        },
        {
            //LL: buttons and texts have 'inherit !important' from class .gantt-header
            id: themeFields.ganttControlsFontColor, 
            param: new ColorBoxField(this.glob, 'Gantt Header Font Color', [], 
                '#777777',
                { hideTransparency: true }
            ),
            section: themeFields.themeSection_Main
        },
        {
            id: themeFields.vertTimeSeparatorLineColor, 
            param: new ColorBoxField(this.glob, 'Vertcal Separating Time Lines Color', [], 
                'rgba(0,0,0,0.3)',
                {
                    hideTransparency: false
                }
            ),
            section: themeFields.themeSection_Main
        },
        {
            id: themeFields.elementsBorderColor,
            param: new ColorBoxField(this.glob, 'Elements Border Color', [], 'rgb(51,51,51)', {
                hideTransparency: false
            }),
            section: themeFields.themeSection_Main
        },
        {
            id: themeFields.horizLineColor,
            param: new ColorBoxField(
                this.glob,
                'Horizontal Separating Lines Color', // Delimiter
                [],
                'rgba(221,221,221,0.6)',
                {
                    hideTransparency: false
                }
            ),
            section: themeFields.themeSection_Main
        },
        {
            id: themeFields.showHorizLines,
            param: new BooleanField(
                this.glob,
                'Show Horizontal Separating Lines', // Delimiter
                [],
                false
            ),
            section: themeFields.themeSection_Main
        },
        {
            id: themeFields.rowHeight,
            param: new NumberField(
                this.glob,
                'Row Height (px)',
                [validators.number.positive, validators.number.integer],
                36,
                {
                    min: 1,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_Main
        },

        //LL:  maybe also dashedStyle, width ?
        {
            id: themeFields.todayLineColor,
            param: new ColorBoxField(this.glob, 'Today (in computer TimeZone) Line Color', [], 'rgba(255, 0, 0, 0.2)', {
                hideTransparency: false
            }),
            section: themeFields.themeSection_Main
        },
        {
            id: themeFields.todayTimeZoneLineColor,
            param: new ColorBoxField(
                this.glob,
                'Today (in Widget TimeZone) Line Color',
                [],
                //'rgba(255, 0, 0, 0.2)',
                '#f00',
                {
                    hideTransparency: false
                }
            ),
            section: themeFields.themeSection_Main
        },

        {
            id: themeFields.showTodayPointersPane,
            param: new BooleanField(this.glob, 'Show Today Pointers Pane', [], true),
            section: themeFields.themeSection_Main
        },

        // -- Data Retrieving

        {
            id: themeFields.swapStartEnd,
            param: new BooleanField(this.glob, 'Swap Start/End when Start is after End', [], false),
            section: themeFields.themeSection_DataRetrieving,
            group: themeFields.themeGroup_DataRetrieving
        },

        {
            id: themeFields.hideEmptyResources,
            param: new BooleanField(this.glob, 'Hide Empty Groups', [], false),
            section: themeFields.themeSection_DataRetrieving,
            group: themeFields.themeGroup_DataRetrieving
        },

        {
            id: themeFields.filterBarsByGroups,
            param: new BooleanField(this.glob, 'Filter Bars by Groups', [], false),
            section: themeFields.themeSection_DataRetrieving,
            group: themeFields.themeGroup_DataRetrieving
        },

        {
            id: themeFields.retrieveGroupsWhenDateIsChanged,
            param: new BooleanField(this.glob, 'Retrieve Groups when Date is changed', [], false),
            section: themeFields.themeSection_DataRetrieving,
            group: themeFields.themeGroup_DataRetrieving
        },

        {
            id: themeFields.retrieveDataFromBackendMode,
            param: new SelectField(
                this.glob,
                'Retrieving Data from Backend mode',
                [],
                periodSelectionOptions.defaultPeriodSelection, // = 'useSchedulerPeriodSelector'
                {
                    values: periodSelectionOptions.values,
                    display: periodSelectionOptions.display
                }
            ),
            section: themeFields.themeSection_DataRetrieving,
            group: themeFields.themeGroup_PeriodSelecton
        },

        {
            id: 'periodSelecton-initialDate:-fictiv',
            param: new StringField(
                glob,
                'Initial Date (choose Today or actual Date), not used when "Data Retrieving mode" is "Use Period Filter Widget":',
                [],
                '',
                {
                    hidden: true,
                    readOnly: true,
                    inline: true // ok
                }
            ),
            section: themeFields.themeSection_DataRetrieving,
            group: themeFields.themeGroup_PeriodSelecton
        },

        {
            id: themeFields.initialDateToday,
            param: new BooleanField(this.glob, 'Today', [], false),
            section: themeFields.themeSection_DataRetrieving,
            group: themeFields.themeGroup_PeriodSelecton
        },

        {
            id: themeFields.initialDate,
            param: new DateTimeField(
                this.glob,
                'Date', // 'Initial Date',
                [validators.date.dateOrNull],
                new Date(2017, 0, 30).toDateString() // =30.01.17
            ),
            section: themeFields.themeSection_DataRetrieving,
            group: themeFields.themeGroup_PeriodSelecton
        },

        // -- TimeLine

        {
            id: themeFields.minDate,
            param: new DateTimeField(this.glob, 'Min Date', [validators.date.dateOrNull], getMinDate()),
            section: themeFields.themeSection_TimeLine,
            group: themeFields.themeGroup_TimeLine
        },

        {
            id: themeFields.maxDate,
            param: new DateTimeField(this.glob, 'Max Date', [validators.date.dateOrNull], getMaxDate()),
            section: themeFields.themeSection_TimeLine,
            group: themeFields.themeGroup_TimeLine
        },

        {
            id: themeFields.cellDuration,
            param: new NumberField(
                this.glob,
                'Cell Duration (minutes)',
                [
                    validators.number.integer,
                    validators.number.range(0, 1440), // 60 * 24 = 1440
                    validators.number.positive,
                    SchedulerValidators.cell_duration.validMinutes
                ],
                30,
                {
                    min: 0,
                    //max: 1440,  // 60 * 24 = 1440
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_TimeLine,
            group: themeFields.themeGroup_TimeLine
        },

        {
            id: themeFields.showZoomBox,
            param: new BooleanField(this.glob, 'Show Zoom Box in Header Panel', [], false),
            section: themeFields.themeSection_TimeLine,
            group: themeFields.themeGroup_ZoomBox
        },

        {
            id: themeFields.zoomValues,
            param: new StringField(this.glob, 'Zoom Values (0-1440) for Cell Duration (comma-separated list)', [], ''),
            section: themeFields.themeSection_TimeLine,
            group: themeFields.themeGroup_ZoomBox
        },

        {
            id: themeFields.showStretch,
            param: new BooleanField(this.glob, 'Show Scaling in Header Panel', [], false),
            section: themeFields.themeSection_TimeLine,
            group: themeFields.themeGroup_Scaling
        },

        {
            id: themeFields.scaling,
            param: new SelectField(this.glob, 'Scaling', [], 'none', {
                values: scalingValuesDef.values,
                display: scalingValuesDef.display
            }),
            section: themeFields.themeSection_TimeLine,
            group: themeFields.themeGroup_Scaling
        },

        {
            id: themeFields.timeCellWidth,
            param: new NumberField(
                this.glob,
                'TimeCell Width(px)',
                [
                    validators.number.positive,
                    validators.number.integer,
                    validators.number.range(minTimeCellWidth, 2147483647) //LL: 3 is min (left border + left padding). Better 4, last has border right
                ],
                60,
                {
                    min: 0,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_TimeLine,
            group: themeFields.themeGroup_Scaling
        },

        {
            id: themeFields.minTimeCellWidthForFit,
            param: new NumberField(
                this.glob,
                'Min TimeCell Width for fit-in-Container (4-10px)',
                [
                    validators.number.positive,
                    validators.number.integer,
                    validators.number.range(minTimeCellWidth, 2147483647)
                ],
                minTimeCellWidth,
                {
                    applyOnEnter: true,
                    min: minTimeCellWidth,
                    max: 10
                }
            ),
            section: themeFields.themeSection_TimeLine,
            group: themeFields.themeGroup_Scaling
        },

        {
            id: themeFields.dst_obtainMethod,
            param: new SelectField(this.glob, 'Method to obtain Switching Days', [], 'calculate', {
                values: ['calculate', 'defineInTheme'],
                display: ['Calculate for current TimeZone', 'Define Switching Days in Table below']
            }),
            section: themeFields.themeSection_TimeLine,
            group: themeFields.themeGroup_DST
        },
        {
            id: themeFields.dst_switchingDays,
            param: new DST_SwitchingDaysClassField(
                this.glob,
                //'Switching to Summer and Winter Time: Dates and Hours',
                'Switching to Summer and Winter Time: Dates and Hours. Used when appropriate Method above is chosen.',
                [
                    SchedulerValidators.DST_SwitchingDays.dst_shouldHaveYear,
                    SchedulerValidators.DST_SwitchingDays.dst_yearsUnique,
                    SchedulerValidators.DST_SwitchingDays.dst_shouldHaveDates,
                    SchedulerValidators.DST_SwitchingDays.dst_differentDates
                ],
                null
            ),
            section: themeFields.themeSection_TimeLine,
            group: themeFields.themeGroup_DST
        },

        // -- Header

        {
            id: themeFields.showGanttHeader,
            param: new BooleanField(this.glob, 'Show Gantt Header', [], true),
            section: themeFields.themeSection_Header
        },

        {
            id: themeFields.llHeaderHeight,
            param: new NumberField(
                this.glob,
                'Header Height(px)', // 'Header Height(px) - temp',
                [
                    validators.number.not_negative,
                    validators.number.integer,
                    validators.number.range(30, 50) //2147483647)
                ],
                36, // 33
                {
                    min: 0,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_Header
        },

        // -- Bars

        {
            id: themeFields.defaultBarBackcolor,
            param: new ColorBoxField(
                this.glob,
                'Bar Background Default Color',
                [],
                '#8fee95', // lightgreen
                {
                    hideTransparency: true
                }
            ),
            section: themeFields.themeSection_Bars
        },
        {
            id: themeFields.defaultBarTextcolor,
            param: new ColorBoxField(
                this.glob,
                'Bar Text Default Color',
                [],
                '#000000', // black
                {
                    hideTransparency: true
                }
            ),
            section: themeFields.themeSection_Bars
        },
        {
            id: themeFields.appointmentLayout, //barLayout,
            param: new SelectField(this.glob, 'Bar Layout', [], 'default', {
                values: ['default', 'SAS', 'Standplan', 'SimpleBars'],
                display: ['default', 'SCORE', 'Standplan', 'Simple Bars']
            }),
            section: themeFields.themeSection_Bars
        },
        {
            id: themeFields.barCursor,
            param: new SelectField(this.glob, 'Bar Cursor', [], 'default', {
                values: ['default', 'pointer', 'help'],
                display: ['default', 'pointer', 'help']
            }),
            section: themeFields.themeSection_Bars
        },

        // - Slider

        {
            id: themeFields.sliderColor,
            param: new ColorBoxField(this.glob, 'Slider Color', [], '#2497E3', {
                hideTransparency: false
            }),
            section: themeFields.themeSection_Slider
        },
        {
            id: themeFields.sliderDisabledColor,
            param: new ColorBoxField(this.glob, 'Slider Disabled Color', [], '#a0a0a0', {
                hideTransparency: false
            }),
            section: themeFields.themeSection_Slider
        },

        {
            id: themeFields.leftMarginBackcolor,
            param: new ColorBoxField(
                this.glob,
                'Margin Background Color', // 'Left Margin Background Color'
                [],
                'transparent', //'#e0e0e0',
                {
                    hideTransparency: false
                    //showText: true  // no need, true is default
                }
            ),
            section: themeFields.themeSection_Margins
        },
        {
            id: themeFields.leftMarginWidth,
            param: new NumberField(
                this.glob,
                'Left Margin Width (px)',
                [validators.number.not_negative, validators.number.integer],
                150,
                {
                    min: 0,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_Margins
        },
        {
            id: themeFields.rightMarginWidth,
            param: new NumberField(
                this.glob,
                'Right Margin Width (px)',
                [validators.number.not_negative, validators.number.integer],
                0,
                {
                    min: 0,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_Margins
        },
        {
            id: themeFields.showSeparatoryLinesInMargins,
            param: new BooleanField(this.glob, 'Show Separatory Lines in Margins', [], false),
            section: themeFields.themeSection_Margins
        },
        {
            id: themeFields.textAlignInMargins,
            param: new SelectField(this.glob, 'Text Align in Margins', [], 'center', {
                values: ['center', 'left', 'right'],
                display: ['center', 'left', 'right']
            }),
            section: themeFields.themeSection_Margins
        },

        {
            id: 'widget-gantt-score-header-presume',
            param: new StringField(
                glob,
                'presume: each Gantt Row has only 1 item for each time point (sequential items)',
                [],
                '',
                {
                    hidden: true, // new
                    readOnly: true,
                    inline: true // ok
                }
            ),
            section: themeFields.themeSection_SCORE
        },
        {
            id: themeFields.sas_barBackColor,
            param: new ColorBoxField(
                this.glob,
                'Bar Back Color',
                [],
                '#90ee90', // = lightgreen
                {
                    hideTransparency: true
                }
            ),
            section: themeFields.themeSection_SCORE
        },
        {
            id: themeFields.sas_barForeColor,
            param: new ColorBoxField(
                this.glob,
                'Bar Fore Color',
                [],
                '#0000ff', // = blue
                {
                    hideTransparency: true
                }
            ),
            section: themeFields.themeSection_SCORE
        },
        {
            id: themeFields.sas_barPattern,
            param: new SelectField(
                this.glob,
                'Bar Pattern',
                [],
                PatternsManager.defaultPattern, //'Solid',
                {
                    values: PatternsManager.generatePatternValueList(),
                    display: PatternsManager.generatePatternDisplayList()
                }
            ),
            section: themeFields.themeSection_SCORE
        },
        {
            id: themeFields.sas_textColor,
            param: new ColorBoxField(
                this.glob,
                'Text Color',
                [],
                '#000000', // = black
                {
                    hideTransparency: true
                }
            ),
            section: themeFields.themeSection_SCORE
        },
        {
            id: themeFields.sas_textOutsideColor,
            param: new ColorBoxField(
                this.glob,
                'Text Color for "Above" and "Below" Labels',
                [],
                function (theme) {
                    return theme['gray-base']; //LL: it is 'On Surface', = getContrastColor(theme, 'surface-bg');
                },
                {
                    hideTransparency: true
                }
            ),
            section: themeFields.themeSection_SCORE,
            deps: ['gray-base']
        },
        {
            id: themeFields.sas_bufferColor,
            param: new ColorBoxField(
                this.glob,
                'Buffer Color',
                [],
                '#00ffff', // = cyan
                {
                    hideTransparency: true
                }
            ),
            section: themeFields.themeSection_SCORE
        },
        {
            id: themeFields.sas_bufferTimeBefore,
            param: new NumberField(
                this.glob,
                'Default Buffer Before (minutes)',
                [validators.number.not_negative, validators.number.integer],
                10,
                {
                    min: 0,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_SCORE
        },
        {
            id: themeFields.sas_bufferTimeAfter,
            param: new NumberField(
                this.glob,
                'Default Buffer After (minutes)',
                [validators.number.not_negative, validators.number.integer],
                10,
                {
                    min: 0,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_SCORE
        },
        {
            id: themeFields.sas_hideBuffers,
            param: new BooleanField(this.glob, 'Hide Buffers', [], false),
            section: themeFields.themeSection_SCORE
        },
        {
            id: themeFields.sas_towSpan,
            param: new NumberField(
                this.glob,
                'Tow Span (minutes)',
                [validators.number.not_negative, validators.number.integer],
                5,
                {
                    min: 0,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_SCORE
        },
        {
            id: themeFields.sas_hasTowBefore,
            param: new BooleanField(this.glob, 'Has Tow Before', [], true),
            section: themeFields.themeSection_SCORE
        },
        {
            id: themeFields.sas_hasTowAfter,
            param: new BooleanField(this.glob, 'Has Tow After', [], true),
            section: themeFields.themeSection_SCORE
        },

        //LL: Standplan: ==============

        {
            id: 'widget-gantt-score-header-presume-standplan',
            param: new StringField(
                glob,
                'presume: each Gantt Row has only 1 item for each time point (sequential items)',
                [],
                '',
                {
                    hidden: true, // new
                    readOnly: true,
                    inline: true // ok
                }
            ),
            section: themeFields.themeSection_Standplan
        },
        {
            id: themeFields.standplan_barBackColor,
            param: new ColorBoxField(
                this.glob,
                'Bar Back Color',
                [],
                '#fffaf0', //LL: Christian: "very slight red tone of white"
                {
                    hideTransparency: true
                }
            ),
            section: themeFields.themeSection_Standplan
        },
        {
            id: themeFields.standplan_textColor,
            param: new ColorBoxField(
                this.glob,
                'Text Color',
                [],
                '#000000', // = black
                {
                    hideTransparency: true
                }
            ),
            section: themeFields.themeSection_Standplan
        },
        {
            id: themeFields.standplan_borderColor,
            param: new ColorBoxField(
                this.glob,
                'Border Color',
                [],
                '#000000', // = black
                {
                    hideTransparency: true
                }
            ),
            section: themeFields.themeSection_Standplan
        },
        {
            id: themeFields.standplan_stripWidth,
            param: new NumberField(
                this.glob,
                'Top and Bottom Strip Width',
                [validators.number.not_negative, validators.number.integer],
                4,
                {
                    min: 0,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_Standplan
        },
        {
            id: themeFields.standplan_towSpanCalculationMode,
            param: new RadioGroupField(
                this.glob,
                'Tow Span Calculation Mode',
                [],
                towSpanCalculation.defaultCalculationMode, //"automatic",  // automatic | in Pixels | in Minutes
                {
                    layout: 'vertical',
                    name: 'RG_gantt_TowSpanCalculationMode', //LL: needed to differ RadioGroup from other RadioGroups
                    //layout: "vertical",  //  default "horizontal"  -- TRY
                    items: [
                        {
                            text: 'automatic (20% of Bar Height)',
                            value: 'automatic'
                        },
                        { text: 'in Pixels', value: 'inPixels' },
                        { text: 'in Minutes', value: 'inMinutes' }
                    ]
                    //displayField: "text",  //LL: is default, no need
                    //valueField: "value"  //LL: is default, no need
                }
            ),
            section: themeFields.themeSection_Standplan
        },
        {
            id: themeFields.standplan_towSpan_inPixels,
            param: new NumberField(
                this.glob,
                'Tow Span (pixels)',
                [validators.number.not_negative, validators.number.integer],
                towSpanCalculation.defaultTowSpanInPixels, // 7,  // 20%, 36/5
                {
                    min: 0,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_Standplan
        },
        {
            id: themeFields.standplan_towSpan,
            param: new NumberField(
                this.glob,
                'Tow Span (minutes)',
                [validators.number.not_negative, validators.number.integer],
                5,
                {
                    min: 0,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_Standplan
        },
        {
            id: themeFields.standplan_hasTowBefore,
            param: new BooleanField(this.glob, 'Has Tow Before', [], true),
            section: themeFields.themeSection_Standplan
        },
        {
            id: themeFields.standplan_hasTowAfter,
            param: new BooleanField(this.glob, 'Has Tow After', [], true),
            section: themeFields.themeSection_Standplan
        }
    ]);
}
